module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "a__Toc448782306"
    }
  }, [_c('span', [_vm._v("Book Description")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText"
  }, [_vm._v("Life is full of decision points—those key moments when what we decide can change everything for better or for worse. These 20 tales describe such instances in young people’s lives, ranging from tragic to triumphant, from horror to fantasy to science fiction. Written by authors new and old, those known for Young Adult writing and those known for Adult novels, a few new and barely known at all, these stories will make you think, make you laugh, make you feel angry, sad, determined, etc. as you examine choices and consequences and consider the many paths a life might take and think about your own.")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText"
  }, [_vm._v("Edited by Hugo-nominated editor Bryan Thomas Schmidt, "), _c('i', [_vm._v("Decision Points")]), _vm._v(" includes both brand new and reprint stories by award winners and bestsellers such as Orson Scott Card, Lois McMaster Bujold, Robert Silverberg, Robert J. Sawyer, Kevin J. Anderson, Jody Lynn Nye, Cory Doctorow, Alethea Kontis, Jonathan Maberry, Nnedi Okorafor, Steven Gould, Mike Resnick, and more. Top authors telling great stories about life changing decisions that may well change yours.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 60
// module chunks = 0